// extracted by mini-css-extract-plugin
module.exports = {"cardList":"style_cardList__2pI7x"};